import * as React from 'react';
import Firebase from "./firebase";
import {User} from 'firebase';
import {IUser} from '../../model/User';


export const FirebaseContext = React.createContext<Firebase | null>(null);
export const AuthUserContext = React.createContext<User | undefined>(undefined);
export const UserContext = React.createContext<IUser>({courses:[]});

export const withFirebase = (Component: React.ComponentType) => (props: any) => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase} />}
  </FirebaseContext.Consumer>
);
